import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { cdBuilderInitialState, IPresentationCdItems } from './interfaces';
import { IValidationResult } from '../../../services/Validation/interfaces';

export const cdBuilderReducer = createSlice({
  name: 'cdBuilder',
  initialState: cdBuilderInitialState,
  reducers: {
    setCdItemsAction: (state, action: PayloadAction<{ orderId: string; value: IPresentationCdItems }>) => {
      state.cdItems[action.payload.orderId] = action.payload.value;
    },
    setValidationAction: (state, action: PayloadAction<{ orderId: string; value: IValidationResult | undefined }>) => {
      state.validation[action.payload.orderId] = action.payload.value;
    },
    setDeletedCdItemsAction: (state, action: PayloadAction<{ orderId: string; value: IPresentationCdItems }>) => {
      state.cdItems[action.payload.orderId] = action.payload.value;
    },
    setCdItemsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.cdItemsFetchStatus = action.payload;
    },
    setCdItemsErrorAction: (state, action: PayloadAction<Error | null>) => {
      state.cdItemsError = action.payload;
    },
    setUpdateCdItemsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.updateCdItemsFetchStatus = action.payload;
    },
    setUpdateCdItemsErrorAction: (state, action: PayloadAction<Error | null>) => {
      state.updateCdItemsError = action.payload;
    },
    setRefiCondition: (state, action: PayloadAction<string | null>) => {
      state.refiCondition = action.payload;
    },
  },
});
export const {
  setCdItemsAction,
  setValidationAction,
  setCdItemsErrorAction,
  setCdItemsFetchStatusAction,
  setRefiCondition,
  setUpdateCdItemsFetchStatusAction,
  setUpdateCdItemsErrorAction,
} = cdBuilderReducer.actions;
